const RESERVED_TOP_LEVEL_SEGMENTS = new Set([
  "login",
  "signup",
  "logout",
  "dashboard",
  "account",
  "apply",
  "collaborations",
  "my-organisation",
  "applications",
  "completed-application",
  "de-minimis",
  "declaration-invitation",
  "our-commitment",
  "receipt",
]);

export function isReservedTopLevelSegment(segment: string): boolean {
  return RESERVED_TOP_LEVEL_SEGMENTS.has(segment);
}

export function getTenantSlugFromPathname(pathname: string): string | null {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return null;

  const firstSegment = segments[0] ?? null;
  if (!firstSegment || isReservedTopLevelSegment(firstSegment)) return null;

  return firstSegment;
}

export function getTenantSlugFromOrgName(orgName?: string | null): string | null {
  return orgName?.trim() || null;
}
